<template>
	<v-row
		align="center"
		justify="center"
		:class="is_mobile_screen || is_tablet_screen ? 'flex-column-reverse' : ''"
	>
		<div v-if="is_mobile_screen" class="mobile-space"></div>
		<v-col cols="12" md="6">
			<h2 class="mb-md-8 ">
				{{ language.panel.main_title }}
			</h2>
			<v-row class="mt-md-2">
				<v-col cols="12" md="4">
					<v-subheader class="subtitle-1 pl-1">
						{{ language.panel.labels.label1 }}
					</v-subheader>
				</v-col>
				<v-col cols="12" md="4">
					<v-select
						v-model="selectedProfil"
						:items="profile"
						suffix="mm"
						hide-details
						outlined
						dense
					>
					</v-select>
				</v-col>
			</v-row>
			<v-row class="mt-md-2">
				<v-col cols="12" md="4">
					<v-subheader class="subtitle-1 pl-1">{{
						language.panel.labels.label2
					}}</v-subheader>
				</v-col>
				<v-col cols="12" md="8" class="mt-md-2">
					<v-chip
						class="mr-6 mb-2 pointer"
						:class="selectedGapSize == 'small' ? 'selected' : ''"
						:ripple="false"
						label
						medium
						@click="changeSize('small')"
						>{{ language.panel.labels.small }} (8-15 mm)
					</v-chip>
					<v-chip
						class="mr-6 mb-2 pointer"
						:class="selectedGapSize == 'medium' ? 'selected' : ''"
						:ripple="false"
						label
						medium
						@click="changeSize('medium')"
						>{{ language.panel.labels.medium }} (15-25 mm)
					</v-chip>
					<v-chip
						v-if="!two_items.includes(selectedProfil)"
						class="mr-6 mb-2 pointer"
						:class="selectedGapSize == 'large' ? 'selected' : ''"
						:ripple="false"
						label
						medium
						@click="changeSize('large')"
						>{{ language.panel.labels.big }} (25-35 mm)
					</v-chip>
				</v-col>
			</v-row>
			<v-row class="caption mt-4 align-center">
				<v-col cols="1">
					<v-icon>mdi-information</v-icon>
				</v-col>
				<v-col cols="11">
					<span>{{ language.panel.info_text1 }}</span>
					<span class="d-block">{{ language.panel.info_text2 }}</span>
				</v-col>
			</v-row>
			<!-- <pre>{{gol_calculat}}</pre> -->
		</v-col>
		<v-col cols="12" md="6">
			<!-- Canvas picture -->
			<canvas
				id="canvas-1"
				width="1200"
				height="800"
				hidpi="off"
				resize="true"
				ref="canvas"
			></canvas>
		</v-col>
		<!-- <pre>{{"H: "+hPanou+" | L: "+lPanou}}</pre> -->
	</v-row>
</template>

<script>
import tinycolor from "tinycolor2";
import paper from "paper";

export default {
	name: "Panel",
	data: function() {
		return {
			// Predefined values
			gol_referinta: 10,
			two_items: [80, 100, 120, 150],
			// Data
			frameSize: 60,
			profilU: 20,
			hBar: 60,
			selectedProfil: this.defaultProfil,
			selectedGapSize: "small",
			nrProfile: null,
			gol_calculat: null,
		};
	},
	props: [
		"language",
		"profile",
		"selectedColor",
		"model",
		"dimensions",
		"configuration",
		"lPanou",
		"hPanou",
		"defaultProfil",
		"is_mobile_screen",
		"is_tablet_screen",
	],
	computed: {
		panelFrame() {
			if (this.configuration.panouri.is) {
				return this.configuration.panouri.panelFrame;
			} else {
				return true;
			}
		},
	},
	watch: {
		gol_calculat() {
			this.$emit("changePanel", {
				selectedProfil: this.selectedProfil,
				selectedGapSize: this.selectedGapSize,
				nrProfile: this.nrProfile,
				gol_calculat: this.gol_calculat,
			});
		},
	},
	methods: {
		changeSize(size) {
			this.selectedGapSize = size;
		},
		nr_profile(profil) {
			let length = 0;
			let dim = 0;
			let nr = 0;

			if (this.model == "horizontal") {
				// hPanou is in m so transform to mm
				length = this.hPanou * 1000;
				dim = this.panelFrame ? length - this.frameSize * 2 : length;
				nr = Math.floor(
					(dim + this.gol_referinta) / (profil + this.gol_referinta)
				);
			} else if (this.model == "vertical") {
				// lPanou is already mm but needs round to integer
				length = Math.round(this.lPanou);
				dim = this.panelFrame ? length - this.frameSize * 2 : length;
				nr = Math.floor(
					(dim - this.gol_referinta) / (profil + this.gol_referinta)
				);
			}

			return nr;
		},
		gol_size(profil, nr) {
			let length = 0;
			let gol = 0;

			if (this.model == "horizontal") {
				length = this.panelFrame
					? Number(this.hPanou * 1000 - this.frameSize * 2)
					: this.hPanou * 1000;
				gol = this.panelFrame
					? (length - nr * profil) / (nr + 1)
					: (length - nr * profil) / (nr - 1);
			} else if (this.model == "vertical") {
				length = this.panelFrame
					? Number(Math.round(this.lPanou) - this.frameSize * 2)
					: Math.round(this.lPanou);
				gol = (length - nr * profil) / (nr + 1);
			}

			this.nrProfile = nr;
			this.gol_calculat = gol.toFixed(2);
			return Number.parseFloat(gol.toFixed(2));
		},
		loadPaper() {
			let canvas = this.$refs.canvas;
			paper.setup(canvas);
			this.updateDrawing();
		},
		clearDrawing() {
			paper.project.clear();
		},
		updateDrawing() {
			let frameSize = this.frameSize;
			let profilU = this.profilU;
			let hBar = this.hBar;
			let size = this.selectedGapSize;
			let margin = this.panelFrame ? frameSize : 0;
			let color = this.selectedColor.hex;
			let darkColor = color;
			let strokeColor = tinycolor(color)
				.darken(15)
				.toString();
			let profil = this.selectedProfil;
			let gol = 10; // backup
			let nrProfile = this.nr_profile(profil);

			// Set profile nr. for other sizes
			if (size == "small") {
				gol = this.gol_size(profil, nrProfile);
			} else if (size == "medium") {
				let nr = nrProfile;

				if (this.model == "horizontal") {
					nr -= 1;
					if (profil == 30 || profil == 60) {
						nr -= 2;
					}
				} else if (this.model == "vertical") {
					nr -= 2;
					if (profil == 30) {
						nr -= 6;
					}
				}

				gol = this.gol_size(profil, nr);
				nrProfile = nr;
			} else if (size == "large") {
				let nr = nrProfile;

				if (this.model == "horizontal") {
					nr -= 2;
					if (profil == 30 || profil == 60) {
						nr -= 3;
					}
				} else if (this.model == "vertical") {
					nr -= 3;
					if (profil == 30) {
						nr -= 9;
					}
				}

				gol = this.gol_size(profil, nr);
				nrProfile = nr;
			}

			let start = margin;
			let end = margin + profil;

			if (this.panelFrame && this.model == "horizontal") {
				start = start + gol;
				end = end + gol;
			}

			// Bars left and right
			var barStyle = {
				strokeColor: strokeColor,
				fillColor: darkColor,
				strokeWidth: 1,
			};

			if (this.model == "horizontal") {
				//
				// Draw horizontal model
				//
				for (let i = 0; i <= nrProfile - 1; i++) {
					// draw profile
					let rectangle = new paper.Rectangle(
						new paper.Point(margin + profilU, start),
						new paper.Point(this.lPanou - profilU - margin, end)
					);
					let path = new paper.Path.Rectangle(rectangle);
					path.fillColor = color;
					// modify start and end for next profile
					start = end + gol;
					end = start + profil;
				}

				if (this.panelFrame) {
					end = end + gol;
				}

				end = end - profil - gol;

				var bar_left = new paper.Rectangle(
					new paper.Point(margin, margin),
					new paper.Point(margin + profilU, end)
				);
				var barLeft = new paper.Path.Rectangle(bar_left);
				barLeft.style = barStyle;

				var bar_right = new paper.Rectangle(
					new paper.Point(this.lPanou - profilU - margin, margin),
					new paper.Point(this.lPanou - margin, end)
				);
				var barRight = new paper.Path.Rectangle(bar_right);
				barRight.style = barStyle;

				// Frames all sides
				if (this.panelFrame) {
					var frameStyle = {
						strokeColor: strokeColor,
						fillColor: darkColor,
						strokeWidth: 1,
					};

					var frameTop = new paper.Path({
						segments: [
							new paper.Point(0, 0),
							new paper.Point(this.lPanou, 0),
							new paper.Point(this.lPanou - margin, margin),
							new paper.Point(margin, margin),
						],
						strokeColor: strokeColor,
						closed: true,
					});
					frameTop.style = frameStyle;

					var frameBottom = new paper.Path({
						segments: [
							new paper.Point(margin, end),
							new paper.Point(this.lPanou - margin, end),
							new paper.Point(this.lPanou, end + margin),
							new paper.Point(0, end + margin),
						],
						strokeColor: strokeColor,
						closed: true,
					});
					frameBottom.style = frameStyle;

					var frameLeft = new paper.Path({
						segments: [
							new paper.Point(0, 0),
							new paper.Point(margin, margin),
							new paper.Point(margin, end),
							new paper.Point(0, end + margin),
						],
						strokeColor: strokeColor,
						closed: true,
					});
					frameLeft.style = frameStyle;

					var frameRight = new paper.Path({
						segments: [
							new paper.Point(this.lPanou - margin, margin),
							new paper.Point(this.lPanou, 0),
							new paper.Point(this.lPanou, end + margin),
							new paper.Point(this.lPanou - margin, end),
						],
						strokeColor: strokeColor,
						closed: true,
					});
					frameRight.style = frameStyle;
				}
			} else if (this.model == "vertical") {
				//
				// Draw vertical model
				//

				let finalEnd = nrProfile * (profil + gol) - gol;
				let height = this.hPanou * 1000;
				let topBarIndent = height * 0.22;
				let bottomBarIndent = height * 0.17;

				// Horizontal bars
				var bar_top = new paper.Rectangle(
					new paper.Point(margin, margin + topBarIndent),
					new paper.Point(finalEnd, margin + topBarIndent + hBar)
				);
				var barTop = new paper.Path.Rectangle(bar_top);
				barTop.fillColor = darkColor;

				var bar_bottom = new paper.Rectangle(
					new paper.Point(margin, height - margin - hBar - bottomBarIndent),
					new paper.Point(finalEnd, height - margin - bottomBarIndent)
				);
				var barBottom = new paper.Path.Rectangle(bar_bottom);
				barBottom.fillColor = darkColor;

				for (let i = 0; i <= nrProfile - 1; i++) {
					// draw profile
					let rectangle = new paper.Rectangle(
						new paper.Point(start, margin),
						new paper.Point(end, this.hPanou * 1000 - margin)
					);
					let path = new paper.Path.Rectangle(rectangle);
					path.fillColor = color;
					path.strokeColor = strokeColor;
					path.strokeWidth = 1;
					// modify start and end for next profile
					start = end + gol;
					end = start + profil;
				}
			}

			// Fit Bounds after redraw
			paper.project.activeLayer.fitBounds(paper.view.bounds);

			// Whenever the view is resized, move the path to its center:
			paper.view.onResize = function() {
				paper.Path.position = paper.view.center;
			};
		},
	},
	updated: function() {
		this.clearDrawing();
		this.$emit("changePanel", {
			selectedProfil: this.selectedProfil,
			selectedGapSize: this.selectedGapSize,
			nrProfile: this.nrProfile,
			gol_calculat: this.gol_calculat,
		});
		this.updateDrawing();
	},
	mounted() {
		this.loadPaper();
	},
};
</script>

<style lang="css">
canvas {
	width: 1600px;
	height: auto;
}
canvas[resize] {
	width: 100%;
	height: 100%;
}
.middle {
	vertical-align: middle;
}
</style>
